// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RczfO","right":"styles_right__gv2pH"};